import styled from 'styled-components';

/* eslint-disable-next-line */
export const NavTabsWrapper = styled.div.attrs({
  className: 's-movies__nav-tabs'
})`
  min-width: 320px;
  background-color: ${({ theme }) => theme.color.bgPrimary};

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.md.width}) {
    width: 100%;
    position: fixed;
    z-index: 9;
    top: ${({ theme }) => theme.breakPoints.sm.header};
    left: 0;
  }
`;
